// extracted by mini-css-extract-plugin
export default {"root":"Background_root__JY5GO","isOpen":"Background_isOpen__vbsQh","co-transparent":"Background_co-transparent__ZZ1La","co-tinted":"Background_co-tinted__ZEvwg"};